var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"video",staticClass:"w-100 video",attrs:{"src":_vm.$cdnImg(_vm.promoVideoPath),"muted":"","loop":"","playsinline":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }